import type { Education } from '@axiom/validation';

export const EducationUtils = {
  sortDisplay: (degrees: Education[] = []) =>
    degrees.sort((a, b) => {
      if (a.yearAwarded === b.yearAwarded) {
        return a.institution.localeCompare(b.institution);
      }
      return (a.yearAwarded ?? 0) > (b.yearAwarded ?? 0) ? -1 : 1;
    }),
};
